<script setup lang="ts">
import MenubarLoginButton from './MenubarLoginButton.vue'; 

</script>

<template>
    <header class="header-style">
        <div class="header-left top-bar-item">
            <div>Corina Widmer</div>
        </div>
        <div class="header-middle top-bar-item">
            <div></div>
        </div>
        <div class="header-right top-bar-item">
            <div>
                <MenubarLoginButton @userProfileClicked="$emit('userProfileClicked')" ></MenubarLoginButton>
            </div>
        </div>
    </header>

</template>

<style scoped>
    .header-style {
        height: 72px;
        background-color: var(--main-color);
        display: flex;
        justify-content: space-between;
        padding: 0 2rem;
        color:white;
    }

    .header-left {
        flex-basis: 141px;
    }

    .top-bar-item {
        display: flex;
        align-items: center;
        padding-left: 2rem;
    }

    @media only screen and (max-width: 629px) {
        .top-bar-item {
            padding-left: 0rem;
        }
    }
</style>
